(() => {
  const initCollection = (root) => {
    if (!root || root.dataset.zCollectionReady === 'true') return;
    root.dataset.zCollectionReady = 'true';

    const sidebar = root.querySelector('[data-z-filter-sidebar]');
    const overlay = root.querySelector('[data-z-filter-overlay]');
    const openButton = root.querySelector('[data-z-filter-open]');
    const closeButton = root.querySelector('[data-z-filter-close]');
    const filterForm = root.querySelector('[data-z-filter-form]');
    const sortForm = root.querySelector('[data-z-sort-form]');
    const sortSelect = root.querySelector('[data-z-sort]');

    const setDrawer = (open) => {
      if (!sidebar) return;
      sidebar.classList.toggle('is-open', open);
      overlay?.classList.toggle('is-open', open);
      sidebar.setAttribute('aria-hidden', String(!open && window.matchMedia('(max-width: 760px)').matches));
      openButton?.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('z-filter-lock', open);
      if (open) closeButton?.focus();
    };

    openButton?.addEventListener('click', () => setDrawer(true));
    closeButton?.addEventListener('click', () => setDrawer(false));
    overlay?.addEventListener('click', () => setDrawer(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sidebar?.classList.contains('is-open')) setDrawer(false);
    });

    filterForm?.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        root.classList.add('is-loading');
        filterForm.requestSubmit();
      });
    });

    filterForm?.addEventListener('submit', () => {
      filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
        if (!input.value) input.disabled = true;
      });
    });

    sortSelect?.addEventListener('change', () => {
      root.classList.add('is-loading');
      sortForm?.requestSubmit();
    });

    const syncSidebar = () => {
      if (!sidebar || window.matchMedia('(max-width: 760px)').matches) return;
      sidebar.removeAttribute('aria-hidden');
      setDrawer(false);
    };
    window.addEventListener('resize', syncSidebar);
    syncSidebar();
  };

  const initAll = () => document.querySelectorAll('[data-z-collection]').forEach(initCollection);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
